import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { clearData, getAllCategory } from '../../../Redux/CategoryRedux';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DataTable from '../Table/DataTable';
import { categoryColumns } from '../Table/TableColumns';
import AddCategory from './AddCategory';
import Main from '../Main';

const ManageCategory = () => {
  const dispatch = useDispatch();
  const { allCategory, newCategory, statusUpdate } = useSelector(
    (state) => state.categoryRedux
  );
  const user = JSON.parse(localStorage.getItem('user'));
  const [categoryDialog, setCategoryDialog] = useState(false);

  useEffect(() => {
    dispatch(getAllCategory(user.userId));
  }, [dispatch, newCategory, statusUpdate]);

  const handleButtonClick = () => {
    // dispatch(clearData());
    setCategoryDialog(true);
  };

  const rows = Array.isArray(allCategory?.categories)
    ? allCategory.categories.map((category, index) => {
        return {
          id: category._id,
          sNo: index + 1,
          category: category.category,
          isActive: category.isActive === true ? 'Yes' : 'No',
        };
      })
    : [];

  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div className='container border p-4'>
          <div className='row'>
            <div className='col-12 text-end'>
              <button
                type='button'
                className='btn btn-success'
                onClick={handleButtonClick}
              >
                <AddCircleIcon style={{ marginRight: '5px' }} />
                Add Category
              </button>
            </div>

            <div className='row mt-3'>
              <div className='col-md-12'>
                <DataTable
                  tableType='addCategory'
                  setCategoryDialog={setCategoryDialog}
                  columns={categoryColumns}
                  rows={rows}
                  user={user}
                />
              </div>
            </div>
          </div>
        </div>
        {user.role === 'admin' && (
          <AddCategory
            user={user}
            categoryDialog={categoryDialog}
            setCategoryDialog={setCategoryDialog}
          />
        )}
      </Box>
    </Main>
  );
};

export default ManageCategory;
